import React from "react";
import { css } from "glamor";

const iconClass = css({
  width: 18,
  height: 18,
  flex: "none",
  flexGrow: 0,
});

export default function CreditCardIcon() {
  return (
    <svg
      className={iconClass}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14.998 3.74951H2.99956C2.17124 3.74951 1.49976 4.421 1.49976 5.24932V12.7484C1.49976 13.5767 2.17124 14.2482 2.99956 14.2482H14.998C15.8263 14.2482 16.4978 13.5767 16.4978 12.7484V5.24932C16.4978 4.421 15.8263 3.74951 14.998 3.74951Z"
        stroke="#475569"
        strokeWidth="1.49981"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.49976 7.49902H16.4978"
        stroke="#475569"
        strokeWidth="1.49981"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
